import { Action } from 'common/interfaces/root';
import { overviewActionTypes as T } from '../actions';

const initState: Overview.DevicesStore = {
  loading: true,
  error: null,
  entries: null,
};

export default (state: Overview.DevicesStore = initState, { type, payload }: Action): Overview.DevicesStore => {
  switch (type) {
    case T.GET_DEVICES_STATISTICS:
      return { ...state, loading: true };

    case T.GET_DEVICES_STATISTICS_SUCCESS:
      return { ...state, loading: false, entries: payload };

    case T.GET_DEVICES_STATISTICS_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
